import { toast } from 'react-toastify';
import ApiConfig from '../../../api/ApiConfig';
import { ERROR, PRE_REQUEST, REMOVE_COOKIE, SEND_DATA } from '../../types';

// send data form api
export const sendData =
  (url, accessToken, data, navigate, redirect) => async (dispatch) => {
    try {
      dispatch({
        type: PRE_REQUEST,
      });
      const res = await ApiConfig.post(`${url}`, data, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (res.status === 201) {
        toast.success('add new item successfully');
        dispatch({
          type: SEND_DATA,
        });
        navigate(redirect);
      }
    } catch (err) {
      if (err?.response?.status === 401) {
        // status failed userUnauthorized token
        dispatch({ type: REMOVE_COOKIE });
      } else if (err?.response?.status === 422) {
        Object.entries(err?.response?.data?.msg).forEach(([key, value]) => {
          dispatch({
            type: ERROR,
            payload: value[0],
          });
        });
      } else if (err?.response?.status === 500) {
        dispatch({
          type: ERROR,
          payload: 'server error',
        });
      } else {
        dispatch({
          type: ERROR,
          payload:
            'There is a problem that the add item was not successful, please try again',
        });
      }
    }
  };
